const service = {
  service: {
    transOil: {
      title: 'x-label:workflow3.service.hydraulic trans oil.hydraulic trans oil',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow3.service.hydraulic trans oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow3.service.hydraulic trans oil.hrs',
              num: '713.2',
              center: true
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow3.service.hydraulic trans oil.screen2.service history :'
            },
            {
              num: '200'
            }
          ]
        }
      ],
      routes: {
        left: 'service/exit',
        right: 'service/engine-oil'
      }
    },
    engineOil: {
      title: 'x-label:workflow3.service.engine oil.engine oil',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow3.service.engine oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow3.service.engine oil.hrs',
              num: '313.2',
              center: true
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow3.service.engine oil.screen2.service history :'
            },
            {
              num: '200'
            }
          ]
        }
      ],
      routes: {
        left: 'service/trans-oil',
        right: 'service/gearbox-oil'
      }
    },
    gearboxOil: {
      title: 'x-label:workflow3.service.deck gear box oil.deck gear box oil',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow3.service.deck gear box oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow3.service.deck gear box oil.hrs',
              num: '313.2',
              center: true
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow3.service.deck gear box oil.screen2.service history :'
            },
            {
              num: '200'
            }
          ]
        }
      ],
      routes: {
        left: 'service/engine-oil',
        right: 'service/dpf-soot'
      }
    },
    dpfSoot: {
      title: 'x-label:workflow3.service.dpf soot.dpf soot %',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow3.service.dpf soot.start regen?',
              center: true
            }
          ]
        }
      ],
      routes: {
        left: 'service/gearbox-oil',
        center: 'regeneration',
        right: 'service/current-error'
      }
    },
    currentError: {
      title: 'x-label:workflow3.service.current error.current error',
      screens: [
        {
          data: [
            {
              label: '@invisible',
            },
            {
              label: 'x-label:workflow3.service.current error.no errors',
              center: true
            }
          ]
        },
        {}
      ],
      routes: {
        left: 'service/dpf-soot',
        right: 'service/input-status'
      }
    },
    inputStatus: {
      title: 'x-label:workflow3.service.status of inputs.status of inputs',
      screens: [
        {
          wrapContent: true,
          data: [
            {
              label: 'x-label:workflow3.service.status of inputs.pto switch',
              invert: true
            },
            {
              label: 'x-label:workflow3.service.status of inputs.neutral',
              invert: true
            },
            {
              label: 'x-label:workflow3.service.status of inputs.oil pressure'
            },
            {
              label: 'x-label:workflow3.service.status of inputs.air filter'
            },
            {
              label: 'x-label:workflow3.service.status of inputs.brake',
              invert: true
            },
            {
              label: 'x-label:workflow3.service.status of inputs.seat',
              invert: true
            },
            {
              label: 'x-label:workflow3.service.status of inputs.engine comm'
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow3.service.status of inputs.screen2.system voltage',
              num: '14.5V'
            },
            {
              label: 'x-label:workflow3.service.status of inputs.screen2.mpa fuel rail pressure',
              num: '0'
            }
          ]
        },
        {
          title: 'x-label:workflow3.service.status of inputs.screen3.status of temp inputs',
          data: [
            [
              {
                label: 'x-label:workflow3.service.status of inputs.screen3.engine temp.c',
                num: '82\xa0'
              },
              {
                label: 'x-label:workflow3.service.status of inputs.screen3.engine temp.f',
                num: '180'
              },
              { label: 'x-label:workflow3.service.status of inputs.screen3.engine temp' }
            ],
            [
              {
                label: 'x-label:workflow3.service.status of inputs.screen3.transmission temp.c',
                num: '76\xa0'
              },
              {
                label: 'x-label:workflow3.service.status of inputs.screen3.transmission temp.f',
                num: '170'
              },
              { label: 'x-label:workflow3.service.status of inputs.screen3.transmission temp' }
            ]
          ]
        },
        {
          title: 'x-label:workflow3.service.status of inputs.screen4.status of temp inputs',
          data: [
            [
              {
                label: 'x-label:workflow3.service.status of inputs.screen4.inlet temp.c',
                num: '82\xa0'
              },
              {
                label: 'x-label:workflow3.service.status of inputs.screen4.inlet temp.f',
                num: '180'
              },
              { label: 'x-label:workflow3.service.status of inputs.screen4.doc inlet temp' }
            ],
            [
              {
                label: 'x-label:workflow3.service.status of inputs.screen4.outlet temp.c',
                num: '76\xa0'
              },
              {
                label: 'x-label:workflow3.service.status of inputs.screen4.outlet temp.f',
                num: '170'
              },
              { label: 'x-label:workflow3.service.status of inputs.screen4.doc outlet temp' }
            ]
          ]
        }
      ],
      routes: {
        left: 'service/current-error',
        right: 'service/output-status'
      }
    },
    outputStatus: {
      title: 'x-label:workflow3.service.status of outputs.status of outputs',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow3.service.status of outputs.module comm',
              invert: true
            },
            {
              label: 'x-label:workflow3.service.status of outputs.pto output'
            },
            {
              label: 'x-label:workflow3.service.status of outputs.alarm output'
            },
            {
              label: 'x-label:workflow3.service.status of outputs.starter output'
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow3.service.status of outputs.screen2.fuel pump power',
              invert: true
            },
            {
              label: 'x-label:workflow3.service.status of outputs.screen2.engine power to run',
              invert: true
            }
          ]
        }
      ],
      routes: {
        left: 'service/input-status',
        right: 'service/machine-info'
      }
    },
    machineInfo: {
      title: 'x-label:workflow3.service.machine information.machine information',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow3.service.machine information.model',
              num: 'no. LZS88CDYM724W0',
              reverseOrder: true
            },
            {
              label: 'x-label:workflow3.service.machine information.serial',
              num: 'no. 402000000',
              reverseOrder: true
            }
          ]
        }
      ],
      routes: {
        left: 'service/output-status',
        right: 'service/module-info'
      }
    },
    moduleInfo: {
      title: 'x-label:workflow3.service.module information.module information',
      screens: [
        {
          data: [
            {
              label: 'x-label:workflow3.service.module information.ldu',
              num: '\xa0'
            },
            {
              label: 'x-label:workflow3.service.module information.hw version',
              num: '000000X'
            },
            {
              label: 'x-label:workflow3.service.module information.sw version',
              num: '000-\xa0000'
            }
          ]
        },
        {
          data: [
            {
              label: 'x-label:workflow3.service.module information.screen2.mcu',
              num: '\xa0'
            },
            {
              label: 'x-label:workflow3.service.module information.screen2.hw version',
              num: '000000X'
            },
            {
              label: 'x-label:workflow3.service.module information.screen2.sw version',
              num: '000- 000'
            }
          ]
        }
      ],
      routes: {
        left: 'service/machine-info',
        right: 'service/exit'
      }
    },
    exit: {
      title: 'x-label:workflow3.service.exit.exit',
      routes: {
        left: 'service/module-info',
        right: 'service/trans-oil'
      }
    }
  }
};

export default service;



// WEBPACK FOOTER //
// ./src/screens/data/flow3/service.js